import {currencyFactor} from '../../components/config/money';

/** Both directories compare amounts with the same snapshot used for display. */
export function orderSortRates(): Record<string,string> {
    return Object.fromEntries(['CNY','EUR','GBP'].flatMap(code=>{
        const rate=currencyFactor('USD',code);
        return rate==null?[]:[[`usd_${code.toLowerCase()}`,String(rate)]];
    }));
}

/** Product and aggregate sorting use the display's existing currency snapshot. */
export function productSortRates(sort=''):Record<string,string> {
    return /^(sale_price|purchase_price|price|final_listing_price):/.test(sort)?orderSortRates():{};
}
